const initialState = {
  selectedUnitIdByPlayerId: {},
};

// Хранит только то, какого великана игрок выбрал для показа в GiantsSupplyToolbar
// (счётчик снабжения + кнопка конвертации) - чисто отображательное состояние,
// не влияющее на раздачу снабжения кликами по фермам/отрядам (та работает как
// обычно, независимо от этого выбора).
// Выбор — по игрокам: в одновременной фазе снабжения сетевой игры великанами
// могут распоряжаться несколько игроков сразу. Игрока в payload.playerId
// подставляет обертка sharedStateReducer (без playerId — текущий игрок)
const giantsAdditionalSupplyReducer = (state = initialState, action) => {
  const playerId = action.payload?.playerId;
  // Состояние прежней формы (общий на партию выбор) читается как пустое
  const selectedUnitIdByPlayerId = state?.selectedUnitIdByPlayerId || {};
  switch (action.type) {
    case 'GIANTS_SELECT_UNIT_FOR_ADDITIONAL_SUPPLY':
      if (!playerId) {
        return state;
      }
      return {
        selectedUnitIdByPlayerId: {
          ...selectedUnitIdByPlayerId,
          [playerId]: action.payload.unitId,
        },
      };

    case 'GIANTS_RESET_ADDITIONAL_SUPPLY_SELECTION':
    case 'COMPLETE_PLAYER_SUPPLY': {
      if (!playerId || !(playerId in selectedUnitIdByPlayerId)) {
        return state;
      }
      const {[playerId]: _removed, ...rest} = selectedUnitIdByPlayerId;
      return {selectedUnitIdByPlayerId: rest};
    }

    case 'COMPLETE_PHASE':
      return Object.keys(selectedUnitIdByPlayerId).length === 0 ? state : initialState;

    default:
      return state;
  }
};

export default giantsAdditionalSupplyReducer;
